import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import { syncTwrDevicesByRooms } from '@app/actions/scenes/twrDevices/twrDevicesByRooms'
import { isIOS } from 'react-device-detect'
import RoomsList
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/DevicesConditions/SelectDeviceCommon/Rooms/RoomsList'
import RoomsListIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/DevicesConditions/SelectDeviceCommon/Rooms/RoomsList'
import { withAccessDenied, withProgressAndErrorMessage, withRefresh } from '@app/hocs'
import { AppDispatch } from '@app/store'
import { AppState } from '@app/@types/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? RoomsListIOS : RoomsList

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { rooms } = state.scenes.twrDevicesByRooms
  const { type: conditionType } = state.scenes.currentSceneCreating.currentCondition
  return {
    conditionType,
    isMobile,
    rooms,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  refresh: syncTwrDevicesByRooms,
  tryAgain: syncTwrDevicesByRooms,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const RoomsListEnhanced = enhance

export default RoomsListEnhanced
